export enum EnPaperSize {
    a0 = 'a0',
    a1 = 'a1',
    a2 = 'a2',
    a3 = 'a3',
    a4 = 'a4'
}